import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import "./Modal.css";
import { FiX } from "react-icons/fi";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { BsInfoCircleFill } from "react-icons/bs";
import { Server } from "../../../../constants";
import parse from "html-react-parser";
import { DataContext } from "../../../pages/ConfiguraHyundai";

const customStyles = {
    overlay: {
        backgroundColor: "rgba(51, 51, 51, 0.5)",
    },
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        padding: "0",
        backgroundColor: "white",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
    },
};

const SlideModal = React.memo((props) => {
    const [modalIsOpen, setIsOpen] = useState(false);
    const [listaAccesorios, setListaAccesorios] = useState([]);
    const [indiceActual, setindiceActual] = useState(1);
    const [indiceTotal, setIndiceTotal] = useState(0)
    const [itemSeleccionado, setItemSeleccionado] = useState({
        imagen: "",
        title: ""
    });
    const [contenido, setContenido] = useState(null);
    const {
        modeloSeleccionado
    } = useContext(DataContext);

    useEffect(() => {
        if (props.tabSelected === 'kit') {
            const obtenerAccesorios = () => {
                let nuevaLista = props.listaKits?.map((item, indice) => {
                    return {
                        ...item,
                        indice: indice + 1
                    }
                })
                if (nuevaLista.length > 0) {
                    setListaAccesorios(nuevaLista);
                    setItemSeleccionado(nuevaLista[0]);
                    setContenido(parse(nuevaLista[0]?.CA_DESCRIPCION));
                    setIndiceTotal(nuevaLista.length);
                }
            }
            obtenerAccesorios();
        } else {
            var lista = []
            lista.push(props.accesorio)
            setListaAccesorios(lista);
            setItemSeleccionado(lista[0]);
            setContenido(parse(lista[0]?.CA_DESCRIPCION));
            setIndiceTotal(0);
        }
    }, [props]);

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    const backImage = () => {
        const item = listaAccesorios.splice(listaAccesorios.length - 1, 1);
        listaAccesorios.splice(0, 0, item[0]);
        setItemSeleccionado(listaAccesorios[0])
        setContenido(parse(listaAccesorios[0]?.CA_DESCRIPCION));
        setindiceActual(listaAccesorios[0].indice)
    }

    const nextImage = () => {
        const item = listaAccesorios.splice(0, 1);
        listaAccesorios.splice(listaAccesorios.length, 1, item[0]);
        setItemSeleccionado(listaAccesorios[0])
        setContenido(parse(listaAccesorios[0]?.CA_DESCRIPCION));
        setindiceActual(listaAccesorios[0].indice)
    }

    return (
        <div>
            <div className="modal-detalles h-head-l h14">
                <p
                    className="text-right"
                    onClick={openModal}>
                    <u>Detalles</u>
                </p>
                <p>
                    <BsInfoCircleFill className="info-icon" />
                </p>
            </div>
            <Modal
                isOpen={modalIsOpen}
                ariaHideApp={false}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Detalle de accesorios"
                aria={{
                    labelledby: "Detalles de item seleccionado",
                    describedby: "Se muestra una imagen y breve descripción del accesorio individual seleccionado"
                }}
            >
                <div className="slideModal">
                    <div className="slide-modal-left">
                        <img src={`${Server}/images/personaliza/modelos/${modeloSeleccionado?.MOD_CODIGO}/accesorios/${itemSeleccionado.CA_COD_ITEM}.jpg`} alt="kit y accesorios" />
                    </div>
                    <div className="slide-modal-right">
                        <div className="right-head">
                            <p className="modal-right-head h-head-of h24">Accesorios</p>
                            <FiX onClick={closeModal} className="icon-quit" />
                        </div>
                        <div className="modal-mid">
                            <div className="mid-price">
                                <p>{itemSeleccionado?.CA_NOMBRE_ACC}</p>
                                {
                                    props.tabSelected === 'kit' ?
                                        null :
                                        <p>{itemSeleccionado?.CA_PVP?.toLocaleString("en-US", {
                                            style: 'currency',
                                            currency: 'USD'
                                        })}</p>
                                }

                            </div>
                            <div className="h-head-l h14">
                                {contenido}
                            </div>
                        </div>
                        {
                            indiceTotal === 0 ?
                                null :
                                <div className="arrowButton">
                                    <div className="arrow ">
                                        <MdOutlineArrowBackIosNew onClick={backImage} size={42} className="left-icon">
                                        </MdOutlineArrowBackIosNew>
                                    </div>
                                    <div className='centrar-global'>
                                        <span>{indiceActual + " de " + indiceTotal}</span>
                                    </div>
                                    <div className="arrow">
                                        <MdOutlineArrowForwardIos onClick={nextImage} size={42} className="left-icon" />
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </Modal>
        </div>
    );
});
export default SlideModal;